// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VvCn","top":"styles_top__o1a38","left":"styles_left__gvrDS","description":"styles_description__3jg7g"};